import { alpha, Avatar, Box, Collapse, makeStyles, Paper, Typography } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import clsx from "clsx";
import { useState } from "react";
import ArrowAnimationIcon from "src/components/Icon/ArrowAnimationIcon";
import { THEME_MODE } from "src/config/constants";
import { formatAddress, numberWithCommas, toFixed } from "src/services/utils";
import FigureText from "../../AssetConfigOption/components/FigureText";
import Incentive from "../../AssetConfigOption/Incentive";
import InterestRateStrategy from "../../AssetConfigOption/InterestRateStrategy";
import ReserveParameter from "../../AssetConfigOption/ReserveParameter";

const useStyle = makeStyles((theme) => ({
  text: {
    color: theme.palette.text.disabled,
  },
  activeItem: {
    backgroundColor: theme.palette.type === THEME_MODE.DARK ? "#7994C1" : "#E1E5EA",
    borderBottom: "1px solid transparent",
  },
  item: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0.5rem 1rem",
    cursor: "pointer",
    borderBottom: `1px solid ${theme.palette.type === THEME_MODE.DARK ? "#3F526F" : "#E1E5EA"}`,
  },
  collapseText: {
    color: theme.palette.text.moreDisabled,
    fontSize: "14px",
    fontWeight: 400,
  },
  activeCollapseText: {
    fontWeight: 500,
  },
  boxItem: {
    backgroundColor: alpha(theme.palette.type === THEME_MODE.DARK ? "#7994C1" : "#E1E5EA", 0.26),
  },
}));

export default function MobileDetailAsset({ asset, setIsDetail }) {
  const cls = useStyle();

  function CollapseItem({ title, CollapseComponent, headerProps, contentProps, ...props }) {
    const [open, setOpen] = useState(false);

    return (
      <Box {...props}>
        <Box className={clsx(cls.item, { [cls.activeItem]: open })} {...headerProps} onClick={() => setOpen(!open)}>
          <Typography className={clsx(cls.collapseText, { [cls.activeCollapseText]: open })}>{title}</Typography>
          <ArrowAnimationIcon isTransform={open} onClick={() => setOpen(!open)} />
        </Box>
        <Collapse in={open}>
          <Box className={cls.boxItem} p={2} {...contentProps}>
            {CollapseComponent}
          </Box>
        </Collapse>
      </Box>
    );
  }

  return (
    <Box>
      <Box display="flex" justifyContent="flex-start" alignItems="center">
        <ArrowBackIosIcon onClick={() => setIsDetail(false)} />
        <Avatar src={asset.image} style={{ width: "30px", height: "30px", marginRight: "0.5rem" }} />
        <Typography variant="h5" className={cls.text}>
          {asset.symbol}
        </Typography>
      </Box>
      <Paper
        style={{ marginTop: "1.5rem", borderRadius: 0, padding: "1rem 0.5rem", marginLeft: -15, marginRight: -15 }}
      >
        <Box>
          <FigureText title="Address" value={formatAddress(asset.address)} justifyContent="space-between" mb={3} />
          <FigureText
            title="Total Supply"
            value={`$${numberWithCommas(toFixed(asset.totalSupply, 2))}`}
            justifyContent="space-between"
            mb={3}
          />
          <FigureText
            title="Total Borrow"
            value={`$${numberWithCommas(toFixed(asset.totalBorrow, 2))}`}
            justifyContent="space-between"
            mb={3}
          />
          <FigureText title="Price" value={`$${toFixed(asset.price, 2)}`} justifyContent="space-between" mb={3} />
        </Box>
        <Box>
          <CollapseItem
            title="Reserve Parameter"
            CollapseComponent={<ReserveParameter asset={asset} />}
            headerProps={{ borderRadius: "6px 6px 0px 0px" }}
          />
          <CollapseItem title="Interest Rate Strategy" CollapseComponent={<InterestRateStrategy asset={asset} />} />
          <CollapseItem
            title="Incentive"
            CollapseComponent={<Incentive asset={asset} />}
            contentProps={{ borderRadius: "0px 0px 6px 6px" }}
          />
        </Box>
      </Paper>
    </Box>
  );
}
